import { atom } from 'recoil';

// Persisted DevExtreme grid state for Projects view (filtering, sorting, column state)
export const projectsGridStateAtom = atom<any>({
  key: 'projectsGridState',
  default: null,
});

// Persisted DevExtreme grid state for Tasks view
export const tasksGridStateAtom = atom<any>({
  key: 'tasksGridState',
  default: null,
});

// Persisted DevExtreme grid state for Entities nested grid
export const entitiesGridStateAtom = atom<any>({
  key: 'entitiesGridState',
  default: null,
});

// Persisted DevExtreme grid state for Deliverables nested grid
export const deliverablesGridStateAtom = atom<any>({
  key: 'deliverablesGridState',
  default: null,
});
